<template>
  <div>
    <el-table :data="items" v-loading="loading" size="small" class="mt-10">
      <el-table-column label="成品编号(分类)">
        <template slot-scope="scope"
          >{{ scope.row.code }}（{{ scope.row.name }}）</template
        >
      </el-table-column>
      <el-table-column label="上报基地" align="center" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.base.name }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="维修日期" prop="created_at_human">
        <template slot-scope="scope">
          {{ $time(scope.row.used_date).format('YYYY-MM-DD') }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="使用次数" prop="usage">
        <template slot-scope="scope">
          {{ scope.row.usage ? `第${scope.row.usage}次` : '-' }}
        </template>
      </el-table-column>
      <el-table-column label="维修更换情况" prop="inspection">
      </el-table-column>
      <el-table-column label="处理措施和结果" prop="solution">
      </el-table-column>
      <el-table-column label="备注/图片/视频" min-width="300">
        <template slot-scope="scope">
          <div v-html="scope.row.remark.split('<br/>').pop()"></div>
          <div class="medio-container">
            <el-image
              v-for="url in scope.row.imgs"
              :key="url"
              style="width: 30px; height: 30px; margin-right: 5px"
              :src="url"
              :preview-src-list="scope.row.imgs"
            >
            </el-image>
            <VideoPlayer :srcs="scope.row.videos"></VideoPlayer>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    items: null,
    loading: false,
    category: Number,
  },
}
</script>